import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftButton", "rightButton"]
  
  connect() {
    // Store the bound method as a property so we can remove it later
    this.boundCheckScroll = () => this.checkScroll()
    this.containerTarget.addEventListener('scroll', this.boundCheckScroll)

    // Initial check
    this.checkScroll()

    // Check on window resize
    this.resizeObserver = new ResizeObserver(this.boundCheckScroll)
    this.resizeObserver.observe(this.containerTarget)
  }

  disconnect() {
    // Clean up the ResizeObserver
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }

    // Remove the scroll event listener
    this.containerTarget.removeEventListener('scroll', this.boundCheckScroll)
  }
  scrollLeft() {
    const scrollAmount = this.containerTarget.clientWidth * 0.8
    this.containerTarget.scrollLeft -= scrollAmount
  }

  scrollRight() {
    const scrollAmount = this.containerTarget.clientWidth * 0.8
    this.containerTarget.scrollLeft += scrollAmount
  }

  checkScroll() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget
    
    // Show/hide left button
    this.leftButtonTarget.classList.toggle('hidden', scrollLeft <= 0)
    
    // Show/hide right button
    this.rightButtonTarget.classList.toggle('hidden', 
      Math.ceil(scrollLeft + clientWidth) >= scrollWidth
    )
  }
}

